import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { reactConfig } from './config/environment';

const rootElement = document.getElementById('root');

const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);
const tree = reactConfig.strictMode ? <React.StrictMode>{app}</React.StrictMode> : app;

// Prerendered routes (scripts/prerender.js, React's own server renderer) are
// hydrated; anything else (dev server, 200.html shell) is rendered from scratch.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, tree);
} else {
  ReactDOM.createRoot(rootElement).render(tree);
}
